import { useState, useEffect } from "react";
import { CoursesNavbar } from "./Components/Navbar/Navbar";
import { Filter } from "./Components/filter/filter";
import { CourseCard } from "./Components/CourseCard/CourseCardRenew";
import { SearchBars } from "./Components/SearchBars/SearchBars";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./RenewPayments.css"; // Import CSS
import { Box, Button, Typography } from "@mui/material";
import config from "config";
import { useSelector } from "react-redux";
import { API_URL, createAxiosInstance } from "../../api";
const RenewPayments = () => {
  const [id, setId] = useState("");
  const paramsId = useParams();
  const location = useLocation();
  const userId = useSelector((state) => state.main.userId);
  const [hasPaid, setHasPaid] = useState(false);

  useEffect(() => {
    if (paramsId) {
      setId(paramsId);
    } else {
      setId(null);
    }
  }, [paramsId]);

  useEffect(() => {
    const checkPaymentStatus = async () => {
      if (!userId) return;
      try {
        const axiosInstance = createAxiosInstance();
        const { data } = await axiosInstance.post(`${API_URL}/api/billings/hasPaid/${userId}`);
        setHasPaid(!!data?.paid);
      } catch (e) {
        setHasPaid(false);
      }
    };
    checkPaymentStatus();
  }, [userId]);

  return (
    <Box className="courses-container myadverts">
      <Box
        sx={{
          maxWidth: "975px",
          margin: "0px 15px 0 auto",
          padding: "20px",
          display: "block",
          width: "100%",
        }}
      >
        {/* Row Container - Title (Left) & Button (Right) */}
        <Box
          sx={{
            display: "inline-flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Title (Fully Left-Aligned) */}
          <Typography
            sx={{
              fontSize: "2.5rem",
              color: "#000",
              fontWeight: "bold",
              marginLeft: "0px",
            }}
          >
            Renew Course
          </Typography>
        </Box>

        {/* Full-Width Divider */}
        <hr
          style={{
            width: "100%",
            borderTop: "1px solid #ccc",
            marginTop: "10px",
          }}
        />
      </Box>
      {/* Main Content */}
      <Box className="content-container">
        {/* Filter */}
        <Box className="filter-container notop">
          <div className="billing-menu notfixed">
            <div className="returnToDash">
              {" "}
              <Link to="/dashboard">
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 122.88 108.06"
                >
                  <title>back-arrow</title>
                  <path d="M63.94,24.28a14.28,14.28,0,0,0-20.36-20L4.1,44.42a14.27,14.27,0,0,0,0,20l38.69,39.35a14.27,14.27,0,0,0,20.35-20L48.06,68.41l60.66-.29a14.27,14.27,0,1,0-.23-28.54l-59.85.28,15.3-15.58Z" />
                </svg>
                Back To Dashboard
              </Link>
            </div>
            <Link
              className={`tab${
                location.pathname === "/my-courses"
                  ? " active " + config["class-name"]
                  : ""
              }`}
              to="/my-courses"
            >
              My Courses
            </Link>
            {hasPaid && (
              <Link
                className={`tab${
                  location.pathname === "/my-courses/billing"
                    ? " active " + config["class-name"]
                    : ""
                }`}
                to="/my-courses/billing"
              >
                My Payments
              </Link>
            )}
            <Link
              className={`tab${
                location.pathname === "/my-courses/renew"
                  ? " active " + config["class-name"]
                  : ""
              }`}
              to="/my-courses/renew"
            >
              Renew Course
            </Link>
          </div>
        </Box>

        {/* Courses */}
        <Box className="courses-list">
          <CourseCard idd={id} />
        </Box>
      </Box>
    </Box>
  );
};

export default RenewPayments;
